import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
// Models
import { IPage } from '@root/models/Page';
// Store
import { useAppSelector } from 'app/hooks/useStore';
// Selectors
import { selectColumnValue } from 'app/store/ui/uiSelectors';
import { selectPagesInWorkspaceByPreEvent } from 'app/store/page/page.selectors';
import { selectNewDesignEnabled } from 'app/store/pagesToolbar/pagesToolbar.selectors';
// Mui
import { Tooltip, Button } from '@mui/material';
// Utils
import { usePagesToolbarContext } from '../utils/usePagesToolbarContext';
// Components
import Icon from 'app/components/Icon';
import { IconButton } from 'app/components/Mui';
import { CARD_WIDTH } from 'app/App.constants';

const GoToPostEvent = () => {
  const { t } = useTranslation();

  // State
  const columnValue:string = useAppSelector(selectColumnValue);
  const newDesignEnabled = useAppSelector(selectNewDesignEnabled);
  const pagesWithPreEvent:Array<IPage> | null = useAppSelector((state:any) => selectPagesInWorkspaceByPreEvent(state, { preEvent: true }));
  const pagesWithoutPreEvent:Array<IPage> | null = useAppSelector((state:any) => selectPagesInWorkspaceByPreEvent(state, { preEvent: false }));

  const { listRef } = usePagesToolbarContext();

  const pages = useMemo(() => {
    const result:any = [];
    if ( pagesWithPreEvent && pagesWithPreEvent.length ){
      result.push({ type: 'placeholder', label: 'Pre-event' });
      for ( let i = 0; i < pagesWithPreEvent.length; i++ ){
        result.push({...pagesWithPreEvent[i], type: 'page', index: i });
      }
    }
    if ( pagesWithoutPreEvent && pagesWithoutPreEvent.length ){
      const index = pagesWithPreEvent ? pagesWithPreEvent.length : 0;
      result.push({ type: 'placeholder', label: 'Post-event' });
      for ( let i = 0; i < pagesWithoutPreEvent.length; i++ ){
        result.push({...pagesWithoutPreEvent[i], type: 'page', index: index + i });
      }
    }
    return result;
    // eslint-disable-next-line
  }, [pagesWithPreEvent, pagesWithoutPreEvent]);

  const handleGoToPostEvent = () => {
    const index = pages.findIndex((p:any) => p.label === 'Post-event');
    if ( listRef.current && index > -1 ){
      const width = listRef.current.props.width;
      const itemsPerRow = columnValue === 'auto' ? Math.floor(width / CARD_WIDTH) : Number(columnValue);
      const rowIndex = Math.floor(index/itemsPerRow);
      listRef.current.scrollToItem(rowIndex, 'center');
    }
  }

  const hasBothPageTypes = pagesWithPreEvent && pagesWithPreEvent.length && pagesWithoutPreEvent && pagesWithoutPreEvent.length;

  if ( !hasBothPageTypes ) return null;
  if ( newDesignEnabled ) return (
    <Tooltip title={t('buttons.goToPostEvent')}>
      <IconButton
        name="Go to post event"
        onClick={handleGoToPostEvent}
      ><Icon icon="go_to_post_event" /></IconButton>
    </Tooltip>
  );
  return (
    <Button
      onClick={handleGoToPostEvent}
      variant="outlined"
      color="primary"
    >{t('pages.workspace.postEventButton')}</Button>
  );
}

export default GoToPostEvent;
